export const VERTICAL_SCROLL_PAGES = [
    'connect-with-',
    'campus-resources',
]

export const HORIZONTAL_SCROLL_PAGES = {
    discover: {
        path: '/discover-your-purple', 
    },
    recruit: {
        path: '/how-we-recruit-1'
    },
}

export const MAIN_MENU_LINKS = [
    { url: 'experienced', title: 'Experienced Hire Careers' },
    { url: 'student', title: 'Student &amp; Recent Graduate Careers' },
    { url: '/connect-with-us/', title: 'Connect With Us' },
]

export const isStoryPage = ( routePath ) => {
    const HORIZONONTAL_SCROLL_KEYS = Object.entries(HORIZONTAL_SCROLL_PAGES)
        .map((value) => value[1].path)
    return HORIZONONTAL_SCROLL_KEYS
        .some(path => routePath.includes(path + '/'))
}

export const isStaticPage = ( routePath ) => {
    return VERTICAL_SCROLL_PAGES
        .some(path => routePath.includes(path))
}